<template>
	<header data-component="header">
		<div class="image-container">
			<nuxt-img class="desktop" :src="heroImage.src" :alt="heroImage.alt" />
		</div>

		<div class="g-row title-row">
			<div class="g-col xxl-21 xs-24">
				<h1 class="-title1 g-indent title">
					{{ titleLine1 }} <br />
					{{ titleLine2 }}
				</h1>
			</div>
		</div>

		<div class="awards-container">
			<div class="award-wrapper">
				<nuxt-img class="desktop" src="/imgs/awards.png" alt="award image" />
			</div>
		</div>
	</header>
</template>

<script setup>
defineProps({
	heroImage: {
		type: Object,
		default: () => ({
			src: '',
			alt: '',
		}),
	},
	titleLine1: { type: String, default: '' },
	titleLine2: { type: String, default: '' },
})
</script>

<style lang="scss" scoped>
[data-component='header'] {
	position: relative;

	width: 100%;

	color: var(--color-geral-black);
	background-color: var(--color-geral-white);

	@include max-width($xs) {
		height: 100svh;
	}

	.image-container {
		background-color: var(--color-geral-black);
		padding-top: rs(50, 50);
		display: flex;
		align-items: center;
		justify-content: center;

		@include max-width($xs) {
			height: 100%;
			width: 100vw;
			overflow: hidden;
			padding-top: 50vh;

			img {
				transform: scale(1.5);
				transform-origin: bottom;
			}
		}
	}

	.awards-container {
		pointer-events: none;

		position: absolute;
		inset: 0;

		.award-wrapper {
			position: sticky;
			top: 0;
			height: 100svh;
			width: 100%;
			display: flex;
			align-items: flex-end;
			justify-content: flex-end;

			padding-right: rs(45, 35);
			padding-bottom: rs(45, 35);

			@include max-width($xs) {
				padding-bottom: rs(120, 95);
			}

			img {
				pointer-events: all;
			}
		}
	}

	.title-row {
		position: absolute;
		top: rs(73, 63);

		.-title1 {
			color: var(--color-geral-white);
		}
	}
}
</style>
